import { XCloseIcon } from '@untitledui-icons/react/line'
import { Modal, ModalOverlay, Dialog } from 'react-aria-components'
import { Button } from '@/components/base/buttons'
import { VoiceCall } from './VoiceCall'
import { cn } from '@/lib/utils'

interface CallAssistantModalProps {
  isOpen: boolean
  onClose: () => void
  assistantId: number
  assistantName: string
  /** E.164 number of the assistant, forwarded to the call as `To` (optional) */
  assistantPhoneNumber?: string | null
}

/**
 * Modal dialog for calling an assistant via browser voice
 */
export function CallAssistantModal({
  isOpen,
  onClose,
  assistantId,
  assistantName,
  assistantPhoneNumber,
}: CallAssistantModalProps) {
  return (
    <ModalOverlay
      isOpen={isOpen}
      onOpenChange={(open) => !open && onClose()}
      isDismissable
      className={cn(
        'fixed inset-0 z-50 flex items-center justify-center',
        'bg-black/50 backdrop-blur-sm',
        'data-entering:animate-in data-entering:fade-in data-entering:duration-200',
        'data-exiting:animate-out data-exiting:fade-out data-exiting:duration-150'
      )}
    >
      <Modal
        className={cn(
          'max-h-[90vh] w-full max-w-md overflow-hidden rounded-2xl',
          'bg-white shadow-xl dark:bg-gray-900',
          'data-entering:animate-in data-entering:zoom-in-95 data-entering:duration-200',
          'data-exiting:animate-out data-exiting:zoom-out-95 data-exiting:duration-150'
        )}
      >
        <Dialog className="outline-none">
          {({ close }) => (
            <>
              {/* Header */}
              <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4 dark:border-gray-700">
                <div className="flex items-center gap-3">
                  <span className="inline-flex items-center rounded-full bg-brand-100 px-3 py-1 text-sm font-medium text-brand-700 dark:bg-brand-900/30 dark:text-brand-300">
                    {assistantName}
                  </span>
                </div>
                <Button
                  color="tertiary"
                  size="sm"
                  onPress={close}
                  iconLeading={XCloseIcon}
                  className="p-2"
                />
              </div>

              {/* Voice Call Component */}
              <div className="p-6">
                <VoiceCall assistantId={assistantId} assistantPhoneNumber={assistantPhoneNumber} />
              </div>
            </>
          )}
        </Dialog>
      </Modal>
    </ModalOverlay>
  )
}

export default CallAssistantModal
